import { API_BASE } from '@/shared/api/client';

/** Public URL of an uploaded file, served by the API with an access check (`GET /api/v1/files/:fileId`). */
export const fileUrl = (fileId: string) => `${API_BASE}/files/${fileId}`;
